module.exports = __webpack_public_path__ + "img/2-38-1.fb57ed68.png";